import React from 'react';

// import { Container } from './styles';

const WarningIcon: React.FC = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="120"
      height="120"
      viewBox="0 0 120 120"
    >
      <defs>
        <clipPath id="clip-path">
          <rect id="Frame" width="120" height="120" transform="translate(134 565)" fill="#d5d5d6" />
        </clipPath>
      </defs>
      <g id="Ilustração" transform="translate(-134 -565)" clipPath="url(#clip-path)">
        <g id="Ilustração-2" data-name="Ilustração" transform="translate(12.406 333.406)">
          <circle id="Ellipse" cx="60" cy="60" r="60" transform="translate(121.594 231.594)" fill="#fef9f1" />
          <circle
            id="Ellipse-2"
            data-name="Ellipse"
            cx="44"
            cy="44"
            r="44"
            transform="translate(137.594 247.594)"
            fill="#f2b050"
          />
          <circle
            id="Ellipse-3"
            data-name="Ellipse"
            cx="4"
            cy="4"
            r="4"
            transform="translate(177.594 303.594)"
            fill="#fff"
          />
          <path
            id="Path"
            d="M181.594,272.537v24"
            transform="translate(0 -0.943)"
            fill="none"
            stroke="#fff"
            strokeLinecap="round"
            strokeWidth="8"
          />
        </g>
      </g>
    </svg>
  );
};

export default WarningIcon;
